import { render, staticRenderFns } from "./ProductImagesTab.vue?vue&type=template&id=06434a94&scoped=true"
import script from "./ProductImagesTab.vue?vue&type=script&lang=ts"
export * from "./ProductImagesTab.vue?vue&type=script&lang=ts"
import style0 from "./ProductImagesTab.vue?vue&type=style&index=0&id=06434a94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06434a94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06434a94')) {
      api.createRecord('06434a94', component.options)
    } else {
      api.reload('06434a94', component.options)
    }
    module.hot.accept("./ProductImagesTab.vue?vue&type=template&id=06434a94&scoped=true", function () {
      api.rerender('06434a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/components/ProductImagesTab.vue"
export default component.exports